import { Component, computed, inject, signal } from '@angular/core';
import { FormField } from '@angular/forms/signals';
import { CampoHoneypotComponent } from '../../../../../shared/components/campo-honeypot/campo-honeypot.component';
import { LucideModule } from '../../../../../shared/modules/lucide.module';
import {
  FORMAS_RECEBIMENTO,
  LIMITE_CARACTERES_ASSUNTO,
  LIMITE_PALAVRAS_DESCRICAO,
  PedidoSicStore,
} from '../pedido-sic.store';

/** A frase única do back-end para o protocolo vinculado — é por ela que o erro vai ao campo. */
const ERRO_PROTOCOLO_VINCULADO = 'Este protocolo não pertence ao seu cadastro ou não foi localizado.';

@Component({
  selector: 'app-etapa-dados-pedido-sic',
  templateUrl: './etapa-dados-pedido-sic.component.html',
  styleUrls: ['./etapa-dados-pedido-sic.component.css'],
  imports: [FormField, LucideModule, CampoHoneypotComponent],
})
export class EtapaDadosPedidoSicComponent {
  protected readonly store = inject(PedidoSicStore);

  readonly formasRecebimento = FORMAS_RECEBIMENTO;
  readonly limitePalavras = LIMITE_PALAVRAS_DESCRICAO;
  readonly limiteAssunto = LIMITE_CARACTERES_ASSUNTO;

  readonly mostrarPendencias = signal(false);

  /** O select de departamento é numérico e fica fora do `formField`; o "tocado" é daqui. */
  readonly departamentoTocado = signal(false);

  /** Os erros do servidor desta etapa, menos o do protocolo, que aparece no próprio campo. */
  readonly errosServidor = computed(() =>
    (this.store.errosServidor()['dados'] ?? []).filter((erro) => erro !== ERRO_PROTOCOLO_VINCULADO)
  );

  readonly erroProtocoloServidor = computed(() =>
    (this.store.errosServidor()['dados'] ?? []).includes(ERRO_PROTOCOLO_VINCULADO) ? ERRO_PROTOCOLO_VINCULADO : null
  );

  readonly caracteresAssunto = computed(() => this.store.dadosPedido().assunto.length);

  destacarPendencias(): void {
    this.mostrarPendencias.set(true);
    this.departamentoTocado.set(true);
    this.store.dadosPedidoForm().markAsTouched();
  }

  escolherDepartamento(evento: Event): void {
    const valor = Number((evento.target as HTMLSelectElement).value);

    this.departamentoTocado.set(true);
    this.store.dadosPedido.update((atual) => ({
      ...atual,
      codDepartamento: Number.isFinite(valor) && valor > 0 ? valor : null,
    }));
  }

  alternarAvisos(evento: Event): void {
    const ligado = (evento.target as HTMLInputElement).checked;
    this.store.dadosPedido.update((atual) => ({ ...atual, receberAvisos: ligado }));
  }

  /** Ao desligar o vínculo, limpa o protocolo para não enviar um número esquecido. */
  alternarProtocolo(evento: Event): void {
    const ligado = (evento.target as HTMLInputElement).checked;

    this.store.dadosPedido.update((atual) => ({
      ...atual,
      temProtocoloAnterior: ligado,
      protocoloAnterior: ligado ? atual.protocoloAnterior : '',
    }));
  }
}
